module.exports = __webpack_public_path__ + "img/sol_cap5.10298524.png";